import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { change, formValueSelector } from 'redux-form';
import _ from 'lodash';

import { TRANSACTION_FORM_NAME } from 'Common/FormEnum';
import { TransactionEnum } from 'Common/FieldEnum';
import AmountCalculator from 'PointOfSale/modules/individualServing/component/AmountCalculator';
import { InputMode } from 'Common/FormEnum';
import { getValueFromInputMode } from 'Common/GeneralHelper';
import { POS_MAX_AMOUNT_PAID_SIZE } from 'Common/Constants';
import { formatToCashAllowNegative } from 'Common/FormHelper';
import { getValue } from 'Common/Components/Keyboard/withKeyboard';
import { getBalance, getPreviousAmountPaid } from '../state/selectors';
import {
  updateBalanceInProfile,
  updatePreviousAmountPaid,
} from '../state/actions';

const FORMAT_TIMER_DELAY = 1000;

class AmountCalculatorContainer extends Component {
  formatToCurrentTimer = null;

  onValueClick = value => {
    if (this.formatToCurrentTimer) clearTimeout(this.formatToCurrentTimer);

    let { amountPaid } = this.props;
    if (!amountPaid) {
      amountPaid = 0;
    }
    const amount = _.round(parseFloat(value + Number(amountPaid)), 2);
    this.updateAmountPaid(formatToCashAllowNegative(amount));
  };

  onChange = e => {
    const {
      balance,
      updateBalanceInProfile,
      updatePreviousAmountPaid,
      previousAmountPaid,
    } = this.props;

    if (this.formatToCurrentTimer) clearTimeout(this.formatToCurrentTimer);
    const value = getValue(e);
    const parsedValue = getValueFromInputMode(
      InputMode.Decimal,
      POS_MAX_AMOUNT_PAID_SIZE,
      value
    );

    this.updateAmountPaid(parsedValue);

    // Logic to update balance when negative numbers are entered
    const amountPaid = Number(parsedValue);

    if (amountPaid <= 0 && previousAmountPaid <= 0) {
      updateBalanceInProfile(balance - previousAmountPaid + amountPaid);
    }
    if (amountPaid > 0 && previousAmountPaid < 0) {
      updateBalanceInProfile(balance - previousAmountPaid);
    }

    if (amountPaid <= 0 && previousAmountPaid > 0) {
      updateBalanceInProfile(balance + amountPaid);
    }
    if (!Number.isNaN(amountPaid)) {
      updatePreviousAmountPaid(amountPaid);
    }
  };

  onBlur = () => {
    if (this.formatToCurrentTimer) clearTimeout(this.formatToCurrentTimer);
    const { amountPaid } = this.props;
    let formattedAmountPaid = formatToCashAllowNegative(amountPaid);
    this.updateAmountPaid(formattedAmountPaid);
  };

  onFocus = () => {
    const { amountPaid } = this.props;
    if (this.formatToCurrentTimer) clearTimeout(this.formatToCurrentTimer);

    const parsedValue = Number(amountPaid) || 0;

    if (parsedValue === 0) {
      this.updateAmountPaid('');
    } else {
      this.updateAmountPaid(amountPaid);
    }
  };

  onClear = () => {
    this.props.change(TRANSACTION_FORM_NAME, TransactionEnum.AmountPaid, '');
  };

  /** Removes last character, formats to current after 1 second */
  onBackspace = () => {
    const { amountPaid } = this.props;

    // cancel oncoming format, user has pressed backspace again within 1 second timeframe
    if (this.formatToCurrentTimer) clearTimeout(this.formatToCurrentTimer);

    // removes last character
    const updatedAmountPaid = String(amountPaid).slice(0, -1);
    this.updateAmountPaid(updatedAmountPaid);
    // format to currency after 1 second
    this.formatToCurrentTimer = setTimeout(() => {
      this.updateAmountPaid(formatToCashAllowNegative(updatedAmountPaid));
    }, FORMAT_TIMER_DELAY);
  };

  updateAmountPaid = amountPaid => {
    this.props.change(
      TRANSACTION_FORM_NAME,
      TransactionEnum.AmountPaid,
      amountPaid
    );
  };

  render() {
    const { amountPaid } = this.props;
    return (
      <AmountCalculator
        amountPaid={amountPaid}
        onValueClick={this.onValueClick}
        onChange={this.onChange}
        onFocus={this.onFocus}
        onBlur={this.onBlur}
        onClear={this.onClear}
        onBackspace={this.onBackspace}
      />
    );
  }
}

const transactionFormSelector = formValueSelector(TRANSACTION_FORM_NAME);

const mapStateToProps = state => {
  return {
    amountPaid:
      transactionFormSelector(state, TransactionEnum.AmountPaid) || '',
    balance: getBalance(state),
    previousAmountPaid: getPreviousAmountPaid(state),
  };
};

const mapDispatchToProps = {
  change,
  updateBalanceInProfile,
  updatePreviousAmountPaid,
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(AmountCalculatorContainer)
);



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/individualServing/container/AmountCalculatorContainer.js